
















import Vue from "vue";
import { mapState, mapMutations } from "vuex";

export default Vue.extend({
  data: () => ({
    city: ""
  }),

  computed: mapState(["cities"]),

  created() {
    this.setTitle("Cities");
  },

  methods: {
    ...mapMutations(["setTitle", "addCity", "removeCity"]),

    submit(event: { target: HTMLFormElement }) {
      this.addCity(this.city);
      event.target.reset();
      this.city = "";
    }
  }
});
